// 编辑器内容区水平内边距
export const EDITOR_CONTENT_HORIZONTAL_PADDING = 32

// 编辑器工具栏高度
export const EDITOR_TOOLBAR_HEIGHT = 48
